import React, { useEffect } from "react";
import { useEnquiryModal } from "./EnquiryModal";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FirstTimeBuyer from "./Homebuyer";
import SEO from "./SEO";
import { useNavigate } from "react-router-dom";
import FooterMain from "./FooterMain";
import { LuxuryProjects } from "./Projects";

export default function PropertyCarousel() {
  const { openModal } = useEnquiryModal();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCardClick = (property) => {
    navigate(`/new-projects/${property.url}`, { state: property });
  };

  return <>
    <SEO
      title="Off-Plan Projects Dubai 2025"
      description="Explore the best off-plan projects in Dubai for 2025. Compare returns, payment plans and top developers."
      canonical="http://localhost:3000/new-projects"
      keywords="off-plan projects dubai 2025, dubai real estate investment guide 2025, dubai property investment opportunities"
    />
    <Navbar />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-center md:mb-6 mb-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#000000] text-center sm:text-left">
          Off Plan Latest Launches
        </h2>
      </div>

      {/* Responsive Property Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {LuxuryProjects.map((p) => {

          // --- Types compute logic ---
          let types = [];
          if (p.type) {
            if (p.type.includes("&")) {
              types = p.type.split("&").map(t => t.trim());
            } else {
              types.push(p.type);
            }
          }

          return (
            <div key={p.id} onClick={() => handleCardClick(p)} className="bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition">
              <div className="relative">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-52 sm:h-56 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute flex flex-col top-2 left-2 gap-2">
                  <div className="flex gap-2 flex-wrap">
                    {types.map((t, i) => (
                      <span
                        key={i}
                        className="bg-white text-[#003153] text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <span className="bg-[#003153] text-white text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap inline-block max-w-[120px] overflow-hidden text-ellipsis">
                    {p.plan}
                  </span>
                </div>
              </div>

              <div className="p-4 sm:p-5">
                <h3 className="text-[#003153] text-3xl font-semibold leading-[32px] mb-3">
                  {p.price}
                </h3>
                <p className="text-lg mb-0.5 font-medium">
                  {p.title}
                </p>
                <h2 className="text-md flex mb-3 items-center text-black">By {p.developer}</h2>
                <p className="text-sm text-[#003153] flex items-center">
                  <i className="fa-solid fa-location-dot mr-1 text-[#003153]"></i>
                  {p.location}
                </p>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // card click prevent
                    openModal({
                      projectTitle: p.project_name,   // THIS IS IMPORTANT
                      projectId: p.id,
                    });
                  }}
                  className="w-full bg-[#003153] text-white font-semibold py-2 mt-4 rounded-lg text-sm sm:text-md hover:bg-[#003153]/90 transition"
                >
                  Enquire Now
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    <FirstTimeBuyer />
    {/* <Footer /> */}
    <FooterMain />
  </>;
}
